export const BAR_RADIUS = 3;

export const STAGGER = 0.05;

export const GRIDLINE_COUNT = 4;

export const LINE_POINTS = [
  [0, 80],
  [9, 74],
  [18, 71],
  [27, 62],
  [36, 60],
  [45, 52],
  [54, 48],
  [63, 41],
  [72, 37],
  [81, 30],
  [90, 26],
  [100, 20],
] as const;

export const AXIS_LABEL_SIZE = { width: 36, height: 10 };

export const BAR_HEIGHTS = [
  ['28%', '40%'],
  ['34%', '48%'],
  ['24%', '38%'],
  ['44%', '60%'],
  ['32%', '42%'],
  ['50%', '68%'],
  ['40%', '62%'],
  ['36%', '26%'],
  ['46%', '30%'],
  ['52%', '34%'],
  ['48%', '28%'],
  ['56%', '36%'],
] as const;
